import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarRegistro(props) {
    const {
        periodoL,
    } = props;

    const [id, setId] = useState("");
    
    const handleChange = e => {
        setId(e.target.value);
    }
    
    const [estadoModal, cambiarEstadoModal] = useState(true);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar periodo"
                botonCerrar="false"
            >
                {periodoL && 
                    <div className="form-floating">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 &&
                        (id &&
                        <a
                            href={`/#/produccion/${id_emp[5]}/corte_caja/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarRegistro.propTypes = {
    periodoL: PropTypes.string.isRequired,
};

export default (FormSeleccionarRegistro);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;